import { useTranslation } from 'react-i18next';
import DataTable from '../../../components/DataTable/DataTable';
import StateBadgeConvocated from '../../../components/StatesBadge/SateBadgeConvocated';
import StateBadge from '../../../components/StatesBadge/StatesBadge';

const ConvocatoriesdGrid = ({
    items,
    filters,
    setFilters,
    isFetching,
    selectedEmployee,
    selectedIds,
    handleSelectEmployee,
    handleClickAction,
    translate
}: any) => {
    const { t } = useTranslation('periodicos');
    return (
        <DataTable
            columnTitles={[
                'Nro',
                'CUIT',
                'Contrato',
                'Fecha Convocatoria',
                'Empleados Incluidos',
                'Estado',
                'Acciones'
            ]}
            columnWidths={['5%', '10%', '10%', '10%', '10%', '10%', '2%']}
            filters={filters}
            setFilters={setFilters}
            isFetching={isFetching}
            items={items}
            selected={selectedEmployee}
            selectedItemFromAction={selectedEmployee}
            onSelectRow={() => {}}
            headers={[
                {
                    type: 'data',
                    upperLabel: (item: any) => item?.id_convocatoria || '-'
                },
                {
                    type: 'data',
                    upperLabel: (item: any) => item?.organismoCentral?.cuit || '-'
                },

                {
                    type: 'data',
                    maxWidth: '250px',
                    upperLabel: (item: any) => `${item?.organismoCentral?.nombre || ''}`
                },
                {
                    type: 'data',
                    upperLabel: (item: any) => {
                        if (!item?.fecha_alta) return '-';
                        return item.fecha_alta.split('T')[0].split('-').reverse().join('/');
                    }
                },

                {
                    type: 'data',
                    maxWidth: '200px',
                    upperLabel: (item: any) => `${item?.cantidad_empleados || ''}`
                },

                {
                    type: 'data',
                    maxWidth: '200px',
                    upperLabel: (item: any) => (
                        <StateBadgeConvocated hideIcon state={item?.id_estado_convocatoria} />
                    )
                },

                {
                    type: 'action',
                    onClick: handleClickAction
                }
            ]}
        />
    );
};

export default ConvocatoriesdGrid;
